import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ComboButton from 'app/components/deprecated/shared/ComboButton';
import { ShelvesOutline } from '@bibliocommons/base-icons';
import BibScreenReaderDescription from 'app/components/shared/BibScreenReaderDescription';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bibBriefShape, childrenShape } from '@bibliocommons/bc-prop-types';
import { SHELF_NAMES } from 'app/constants/ShelfConstants';

import './AddToShelfComboButton.scss';

const defaultShelfOrder = [SHELF_NAMES.FOR_LATER, SHELF_NAMES.IN_PROGRESS, SHELF_NAMES.COMPLETED];

export default class AddToShelfComboButton extends React.PureComponent {
  getContentScreenReaderTitle() {
    const { bibBrief } = this.props;

    return bibBrief ? <BibScreenReaderDescription bibBrief={bibBrief} /> : <FormattedMessage id="selected_items" />;
  }

  getShelfOptions() {
    const shelfNamesOrder = this.props.primaryShelfAction ? this.setPrimaryShelfOption() : defaultShelfOrder;
    const shelfNamesMap = shelfNamesOrder.map((name, index) => ({
      label: this.renderAddToShelfButtonContent(name, index),
      value: name
    }));
    return shelfNamesMap;
  }

  setPrimaryShelfOption() {
    return [
      this.props.primaryShelfAction,
      ...defaultShelfOrder.filter(shelf => shelf !== this.props.primaryShelfAction)
    ];
  }

  renderShelfSrMessage(shelfName) {
    return (
      <FormattedMessage
        id="ada_add_to_named_shelf"
        values={{
          title: this.getContentScreenReaderTitle(),
          shelf: shelfName
        }}
      />
    );
  }

  renderAddToShelfButtonContent(name, index) {
    const formattedShelfName = <FormattedMessage id={`label_shelf_${name}`} />;
    return (
      <span>
        {index === 0 ? <ShelvesOutline color="currentColor" /> : null}
        <span className="shelf-name-text" aria-hidden="true">
          {formattedShelfName}
        </span>

        <ScreenReaderMessage>{this.renderShelfSrMessage(name)}</ScreenReaderMessage>
      </span>
    );
  }

  renderSecondaryAriaLabel() {
    return <FormattedMessage id="ada_add_to_different_shelf" values={{ title: this.getContentScreenReaderTitle() }} />;
  }

  render() {
    return (
      <div className="cp-add-to-shelf-combo-button">
        <ComboButton
          ButtonTag={this.props.ButtonTag}
          right
          block
          disabled={this.props.disabled}
          isLoading={this.props.isLoading}
          options={this.getShelfOptions()}
          secondaryAriaLabel={this.renderSecondaryAriaLabel()}
          handleClick={this.props.handleClick}
          dataKey="bib-shelf-button"
        >
          {this.props.children}
        </ComboButton>
      </div>
    );
  }
}

AddToShelfComboButton.propTypes = {
  disabled: PropTypes.bool,
  children: childrenShape,
  handleClick: PropTypes.func,
  bibBrief: bibBriefShape,
  isLoading: PropTypes.bool,
  ButtonTag: PropTypes.func,
  primaryShelfAction: PropTypes.string
};
